import { blue } from '@material-ui/core/colors';

export default {
  colorSecondary: {
    color: blue[700],
  },
};
